import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui';
import type { CampaignOffer } from './campaignOfferCopy';

/** First-deposit offers stay visible and say whether the one slot is still open. */
export default function CampaignOfferMarks({ offer }: { offer: CampaignOffer }) {
  const { t } = useTranslation();
  if (offer.application !== 'first_deposit') return null;

  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5">
      <Badge tone="warning" dot={false} size="sm">
        {t('campaignBonus.oneTime', '1 time')}
      </Badge>
      <Badge tone={offer.used ? 'neutral' : 'success'} dot={false} size="sm">
        {offer.used ? t('campaignBonus.used', 'Used') : t('campaignBonus.notUsed', 'Not used')}
      </Badge>
    </div>
  );
}
